// Author Liu Cui Cui
// Date 2023-07-19 15:09:39

import * as model from "@/model/sithMes/mst/SithMesMstMaterialDrawingManagementModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstMaterialDrawingManagement(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .buildStore()
